import { render } from "./SideBarRow.vue?vue&type=template&id=d98c7108&scoped=true"
import script from "./SideBarRow.vue?vue&type=script&lang=js"
export * from "./SideBarRow.vue?vue&type=script&lang=js"

import "./SideBarRow.vue?vue&type=style&index=0&id=d98c7108&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d98c7108"]])

export default __exports__